import { render, staticRenderFns } from "./InsertionResultLoader.vue?vue&type=template&id=49fab89d&scoped=true&"
import script from "./InsertionResultLoader.vue?vue&type=script&lang=js&"
export * from "./InsertionResultLoader.vue?vue&type=script&lang=js&"
import style0 from "./InsertionResultLoader.vue?vue&type=style&index=0&id=49fab89d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fab89d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
